import { render, staticRenderFns } from "./veStuCheckStudentMy.vue?vue&type=template&id=5f140f36&scoped=true"
import script from "./veStuCheckStudentMy.vue?vue&type=script&lang=js"
export * from "./veStuCheckStudentMy.vue?vue&type=script&lang=js"
import style0 from "./veStuCheckStudentMy.vue?vue&type=style&index=0&id=5f140f36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f140f36",
  null
  
)

export default component.exports